import type { Translations } from '../../types';

// Per-language translation pack — split out of i18n.ts for lazy loading.
// Only Hebrew loads synchronously; en/ar/ru are dynamic-imported on demand.
const dict: Translations = {
    app_title: 'בגרות מתמטיקה',
    login_title: 'התחברות',
    login_email: 'אימייל',
    login_password: 'סיסמה',
    login_submit: 'התחבר',
    login_register: 'הרשמה',
    login_google: 'התחבר עם Google',
    login_guest: 'כניסה כאורח',
    login_remember: 'זכור אותי',
    login_role_student: 'תלמיד',
    login_role_teacher: 'מורה',
    login_role_parent: 'הורה',
    dash_welcome: 'שלום',
    dash_daily_goal: 'יעד יומי',
    dash_streak: 'רצף',
    dash_level: 'רמה',
    dash_xp: 'נקודות ניסיון',
    dash_practice: 'תרגול',
    dash_exam: 'בחינה',
    dash_stats: 'סטטיסטיקות',
    dash_weak_topics: 'נושאים לחיזוק',
    practice_title: 'תרגול',
    practice_hint: 'רמז',
    practice_next: 'שאלה הבאה',
    practice_submit: 'בדוק תשובה',
    practice_correct: 'נכון!',
    practice_wrong: 'לא נכון',
    practice_end: 'סיים תרגול',
    practice_level: 'רמה',
    exam_title: 'מבחן מתמטיקה',
    exam_start: 'התחל מבחן',
    exam_submit: 'הגש מבחן',
    exam_time_left: 'זמן נותר',
    exam_results: 'תוצאות מבחן',
    exam_score: 'ציון',
    exam_review: 'סקירת תשובות',
    nav_dashboard: 'דשבורד',
    nav_practice: 'תרגול',
    nav_exam: 'מבחן',
    nav_profile: 'פרופיל',
    questions: 'שאלות',
    correct: 'נכון',
    wrong: 'שגוי',
    cancel: 'ביטול',
    confirm: 'אישור',
    loading: 'טוען...',
    offline: 'אין חיבור לאינטרנט',
    nav_goals: 'יעדים',
    nav_settings: 'הגדרות',
    nav_achievements: 'הישגים',
    nav_leaderboard: 'דירוג',
    goals_title: 'היעדים שלי',
    goals_add: 'הוסף יעד חדש',
    settings_title: 'הגדרות',
    settings_sound: 'צלילים ורטט',
    settings_lang: 'שפה',
    settings_track: 'רמת לימוד',
    settings_clear: 'מחק נתונים',
    settings_logout: 'התנתק',
    summary_title: 'סיכום תרגול',
    summary_correct: 'תשובות נכונות',
    summary_wrong: 'שגיאות',
    summary_time: 'זמן',
    summary_streak: 'רצף מרבי',
    back: 'חזור',
    retry: 'נסה שוב',
    share: 'שתף',
    // Dashboard
    dash_api_error: 'שגיאה בטעינת נתונים מהשרת',
    dash_today: 'היום',
    dash_total: 'סה"כ',
    dash_best_exam: 'שיא בחינה',
    dash_mastery: 'שליטה',
    dash_duel: 'דו-קרב',
    dash_weak_topics_btn: 'נושאים חלשים',
    dash_by_exam: 'לפי בגרות',
    dash_resume: 'המשך מאיפה שעצרת',
    dash_bookmarked: 'שאלות מסומנות',
    dash_bookmarked_sub: 'תרגל שאלות ששמרת',
    dash_weekly: 'פעילות שבועית',
    dash_progress: 'התקדמות כללית',
    dash_questions_label: 'שאלות',
    dash_mastery_label: 'שליטה',
    dash_exam_history: 'היסטוריית בחינות',
    dash_predicted_score: 'ציון בחינה משוער',
    dash_predicted_based: 'לפי {n} שאלות שתרגלת',
    dash_topic_mastery: 'שליטה לפי נושא',
    dash_goals: 'יעדים',
    dash_view_all: 'הצג הכל',
    dash_study_time: 'זמן לימוד היום',
    dash_footer: 'בגרות — פלטפורמת הלמידה שלך',
    // Track
    track_units: 'יח"ל',
    track_choose: 'בחר רמת לימוד',
    track_change_later: 'תוכל לשנות בכל עת מההגדרות',
    track_3u_desc: 'רמה בסיסית',
    track_4u_desc: 'רמה בינונית',
    track_5u_desc: 'רמה מוגברת',
    track_start: 'בוא נתחיל!',
    // Login
    login_subtitle: 'הכנה חכמה לבגרות במתמטיקה',
    login_or_email: 'או התחבר עם אימייל',
    login_connecting: 'מתחבר...',
    login_no_account: 'אין לך חשבון? הירשם',
    login_has_account: 'יש לך חשבון? התחבר',
    login_full_name: 'שם מלא',
    login_google_failed: 'ההתחברות עם Google נכשלה',
    login_google_not_configured: 'התחברות עם Google לא מוגדרת. נסה שיטה אחרת.',
    login_server_waking: 'החיבור לוקח יותר מהרגיל (תקופת פיילוט). נסי שוב בעוד כמה שניות.',
    // Stats / Dashboard cards added after the initial i18n pass
    review_due_one: 'שאלה אחת לחזרה היום',
    review_due_many: '{n} שאלות לחזרה היום',
    dashboard_path_label: 'המסלול שלי',
    dashboard_admin_label: 'ניהול ואנליטיקס',
    duel_pick_difficulty: 'בחר רמת קושי',
    settings_show_intro: 'הצג שוב את האונבורדינג הקצר',
    settings_show_intro_desc: 'ארבע שקפי פתיחה — לא נמחק שום נתון לימוד',
    // Duel
    duel_searching: 'מחפש יריב...',
    duel_question_of: 'שאלה {n} מתוך {total}',
    duel_won: 'ניצחת!',
    duel_tied: 'תיקו!',
    duel_lost: 'נסיון טוב!',
    duel_you: 'את/ה',
    duel_of_questions: 'מתוך {n} שאלות',
    duel_details: 'פירוט',
    duel_back: 'חזור לדשבורד',
    duel_new: 'דו-קרב חדש',
    // Leaderboard
    leaderboard_title: '🏅 לוח מובילים',
    leaderboard_level: 'רמה',
    leaderboard_you: 'אתה',
    leaderboard_empty: 'לוח המובילים ריק כרגע',
    // Exam
    exam_simulation: 'בחינת בגרות — סימולציה',
    exam_loading: 'טוען בחינה...',
    exam_question_of: 'שאלה {n} מתוך {total}',
    exam_mark: 'סמן',
    exam_marked: 'מסומן',
    exam_prev: 'הקודם',
    exam_next: 'הבא',
    exam_skip_unanswered: 'דלג לבלתי נענה',
    exam_submit_title: 'הגשת בחינה',
    exam_unanswered: 'שאלות ללא תשובה',
    exam_marked_review: 'שאלות מסומנות לבדיקה',
    exam_quit_title: 'יציאה מהבחינה',
    exam_quit_warning: 'אם תצא/י, התשובות לא יישמרו.',
    exam_continue: 'המשך בחינה',
    exam_exit: 'צא',
    // Practice
    practice_exit: 'יציאה',
    practice_hint_remaining: 'נותרו',
    practice_formula: 'נוסחה/כלל',
    practice_new_q: 'חדשה',
    practice_mastered_q: 'נשלטת',
    practice_practiced_q: 'תורגלה',
    practice_report: 'דווח על שאלה שגויה',
    practice_reported: 'דווח',
    practice_your_answer: 'תשובתך',
    practice_correct_answer: 'תשובה נכונה',
    practice_explanation: 'הסבר',
    practice_alt_methods: 'דרכי פתרון נוספות',
    practice_next_q: 'שאלה הבאה',
    practice_finish: 'סיום תרגול',
    practice_quit_title: 'לצאת מהתרגול?',
    practice_continue: 'המשך',
    practice_low_accuracy: 'דיוק נמוך — שקלו לחזור על החומר או לרדת רמה',
    // AppShell nav
    nav_duel: 'דו-קרב',
    // General
    all_topics: 'כל הנושאים',
    general_topic: 'כללי',
    topic_general: 'כללי',
    hours: 'שעות',
    minutes: 'דקות',
    // Grade labels
    grade_excellent: 'מצוין',
    grade_very_good: 'טוב מאוד',
    grade_good: 'טוב',
    grade_pass: 'מספיק',
    grade_fail: 'נכשל',
    error_boundary_title: 'אופס! משהו השתבש',
    error_boundary_subtitle: 'קרתה שגיאה לא צפויה. אל דאגה — התקדמות הלמידה שלך נשמרה.',
    error_boundary_retry: 'נסה שוב',
    error_boundary_back: 'חזרה לדשבורד',
    error_loading_questions: 'שגיאה בטעינת שאלות. נסה שוב.',
    error_submitting_answer: 'שגיאה בשליחת התשובה',
    login_guest_name: 'אורח',
    goal_daily: 'יומי',
    goal_weekly: 'שבועי',
    goal_total: 'כולל',
    btn_back: 'חזור',
    btn_retry: 'נסה שוב',
    leaderboard_empty_desc: 'התחל לתרגל כדי להופיע כאן!',
    duel_vs_ai: 'דו-קרב מול בוט',
    duel_vs_ai_note: 'אתה מתחרה מול יריב אוטומטי',
    achievement_unlocked: 'הישג חדש',
    // Lesson Mode
    lesson_lang_quantity: 'כמות',
    lesson_lang_shape: 'צורה',
    lesson_lang_change: 'שינוי',
    lesson_lang_uncertainty: 'אי־ודאות',
    lesson_filter_all: 'הכל',
    lesson_back_list: '← חזרה לרשימה',
    lesson_back_topics: '← חזרה לרשימת הנושאים',
    lesson_topic_load_err: 'שגיאה בטעינת הנושא',
    lesson_load_err: 'שגיאה בטעינה',
    lesson_topic_not_found: 'לא נמצא',
    lesson_section_plain: 'מה זה אומר בפשטות',
    lesson_section_philosophy: 'פילוסופיית התחום',
    lesson_section_logic: 'איך חושבים כשפותרים',
    lesson_section_formulas: 'נוסחאות וכלים',
    lesson_section_example: 'דוגמה',
    lesson_section_mistakes: 'טעויות נפוצות שאסור לעשות',
    lesson_section_bagrut: 'איפה זה מופיע בבגרות ({track})',
    lesson_section_idea: 'איך נראה במערכת',
    lesson_section_leads_to: 'לאן זה ממשיך בתיכון',
    lesson_practice_btn: '📐 תרגל את הנושא הזה עכשיו',
    lesson_library_title: '📚 ספריית הנושאים',
    lesson_library_desc: 'הסברים מקיפים לכל נושא: רעיון, פילוסופיה, נוסחאות, דוגמה וטעויות נפוצות. מסומן לפי המסלול שלך ({track}).',
    lesson_no_topics: 'אין נושאים במסנן הזה.',
    lesson_loading: 'טוען...',
    // Dashboard extra
    dash_topic_library: 'ספריית נושאים',
    dash_resume_msg: 'המשך מאיפה שעצרת',
    dash_bookmarked_msg: 'שאלות מסומנות',
    dash_bookmarked_sub_msg: 'תרגל שאלות ששמרת',
    dash_weekly_activity: 'פעילות שבועית',
    dash_questions_count: 'שאלות',
    dash_mastery_count: 'שליטה',
    dash_predicted_score_label: 'ציון בחינה משוער',
    dash_predicted_based_msg: 'לפי {n} שאלות שתרגלת',
    dash_goals_label: 'יעדים',
    dash_level_short: 'רמה',
    dash_streak_days: 'ימים',
    dash_xp_label: 'XP',
    // Settings extra
    settings_profile: 'פרופיל',
    settings_data: 'נתונים',
    settings_clear_warning: 'פעולה זו תמחק את כל הנתונים המקומיים שלך (היסטוריה, יעדים, סימניות). האם להמשיך?',
    settings_delete_all: 'מחק הכל',
    settings_clear_link: 'מחק את כל הנתונים המקומיים',
    // Achievements
    ach_to_next_level: 'לרמה הבאה',
    ach_earned: 'הושגו',
    ach_locked: 'נעולים',
    ach_empty: 'התחל לתרגל כדי לפתוח הישגים!',
    // Goals
    goals_subtitle: 'הגדר יעדים ועקוב אחרי ההתקדמות שלך',
    goals_empty: 'עדיין אין יעדים. הוסף את היעד הראשון שלך!',
    goals_add_short: 'הוספת יעד',
    goals_quick_presets: 'יעדים מוכנים:',
    goals_or_custom: 'או צור יעד מותאם:',
    goals_name_placeholder: 'שם היעד',
    btn_add: 'הוסף',
    // Practice / Exam
    exam_topics_load_err: 'שגיאה בטעינת נושאים',
    exam_no_topics: 'לא נמצאו נושאים — נסה שוב מאוחר יותר',
    exam_no_questions_topic: 'אין שאלות בנושא זה',
    exam_questions_load_err: 'שגיאה בטעינת שאלות',
    exam_mixed_practice_title: 'תרגול מעורב — כל הנושאים',
    exam_practice_by_topics: 'תרגול לפי נושאי בגרות',
    exam_mixed_subtitle: '40 שאלות אקראיות מכל הנושאים',
    weak_no_weak: 'אין נושאים חלשים כרגע — תרגל יותר!',
    weak_loading: 'מחשב נושאים חלשים...',
    weak_title: '🎯 תרגול נושאים חלשים',
    weak_subtitle: 'מתמקדים בנושאים שצריך לחזק',
    weak_practice_subtitle: 'תרגל את הנושאים שצריכים חיזוק',
    weak_start_with: 'התחל עם הנושא החלש ביותר',
    weak_great_no_weak: 'כל הכבוד! אין נושאים חלשים',
    weak_practice_more: 'תרגל עוד שאלות כדי שנוכל לזהות נושאים לחיזוק',
    weak_untouched_title: 'נושאים שעדיין לא תרגלת',
    weak_correct_label: 'נכונות',
    weak_questions_label: 'שאלות',
    exam_questions_avail: 'שאלות זמינות — בחר נושא לתרגול',
    exam_topics_count: 'נושאים',
    exam_questions_count: 'שאלות',
    exam_no_topics_avail: 'אין נושאים זמינים עדיין',
    exam_rel_critical: 'קריטי לבגרות',
    exam_rel_core: 'נושא ליבה',
    exam_rel_high: 'חשוב לבגרות',
    exam_rel_medium: 'מומלץ',
    exam_rel_low: 'משני',
    // AppShell
    skip_to_main: 'דלג לתוכן הראשי',
    nav_main: 'ניווט ראשי',
    nav_bottom: 'ניווט תחתון',
    // Dashboard misc
    dash_questions: 'שאלות',
    dash_quote_1: 'כל שאלה שתפתור היום — צעד קדימה מחר.',
    dash_quote_2: 'אתה לא צריך להיות מושלם — רק להשתפר כל יום קצת.',
    dash_quote_3: 'המסע של אלף שאלות מתחיל בשאלה אחת.',
    dash_quote_4: 'כל טעות היא הזדמנות ללמוד משהו חדש.',
    dash_quote_5: 'התמדה מנצחת כישרון.',
    // Achievements (data)
    ach_first_correct_name: 'צעד ראשון',
    ach_first_correct_desc: 'ענית נכון על השאלה הראשונה',
    ach_streak_3_name: 'רצף 3',
    ach_streak_3_desc: 'ענית נכון על 3 שאלות ברצף',
    ach_streak_5_name: 'רצף 5',
    ach_streak_5_desc: 'ענית נכון על 5 שאלות ברצף',
    ach_streak_10_name: 'רצף 10',
    ach_streak_10_desc: 'ענית נכון על 10 שאלות ברצף',
    ach_no_hints_name: 'בלי עזרה',
    ach_no_hints_desc: 'ענית נכון על 5 שאלות בלי רמזים',
    ach_speed_demon_name: 'ברק',
    ach_speed_demon_desc: 'ענית נכון תוך פחות מ-10 שניות',
    ach_q50_name: 'חצי מאה',
    ach_q50_desc: 'ענית על 50 שאלות',
    ach_q100_name: 'מאה שאלות',
    ach_q100_desc: 'ענית על 100 שאלות',
    ach_q500_name: 'מתמטיקאי מתחיל',
    ach_q500_desc: 'ענית על 500 שאלות',
    ach_exam_pass_name: 'עובר את המבחן',
    ach_exam_pass_desc: 'קיבלת 55% ומעלה במבחן',
    ach_exam_good_name: 'ציון טוב',
    ach_exam_good_desc: 'קיבלת 75% ומעלה במבחן',
    ach_exam_excellent_name: 'ציון מעולה',
    ach_exam_excellent_desc: 'קיבלת 90% ומעלה במבחן',
    ach_exam_perfect_name: 'מושלם!',
    ach_exam_perfect_desc: 'קיבלת 100% במבחן',
    ach_daily_10_name: 'התחלה טובה',
    ach_daily_10_desc: 'ענית על 10 שאלות ביום אחד',
    ach_daily_30_name: 'יום פרודוקטיבי',
    ach_daily_30_desc: 'ענית על 30 שאלות ביום אחד',
    ach_duel_win_name: 'מנצח',
    ach_duel_win_desc: 'ניצחת בדו-קרב',
    ach_all_topics_name: 'פוליגלוט',
    ach_all_topics_desc: 'תרגלת בכל הנושאים',
};

export default dict;
